// @flow
const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
const RESET_FEATURE_FLAGS = 'RESET_FEATURE_FLAGS';

export function setFeatureFlags(featureFlags = {}) {
  return {
    type: SET_FEATURE_FLAGS,
    featureFlags,
  };
}

export function resetFeatureFlags() {
  return {
    type: RESET_FEATURE_FLAGS,
  };
}

const initialState = {
  featureFlags: {},
};

export default function featureFlags(state = initialState, action) {
  switch (action.type) {
    case SET_FEATURE_FLAGS:
      return {
        ...state,
        featureFlags: action.featureFlags,
      };
    case RESET_FEATURE_FLAGS:
      return {
        ...state,
        featureFlags: {},
      };

    default:
      return state;
  }
}
